import { DownloadRequestComponent } from './../features/download/download-request/download-request.component';
import { MainComponent } from './main.component';
import { documentRoutes } from '../features/document/document-routing.module';
import { LoginComponent } from '../login/login.component';
import { AuthGuard } from '../auth-guard.service';
import { reportRoutes } from '../features/report/report-routing.module';
import { searchRoutes } from '../features/search/search-routing.module';
import { saleTaxRoutes } from '../features/saletax/saletax-routing.module';
import { profileRoutes } from '../features/profile/profile-routing.module';
import { dashboardRoutes } from '../features/dashboard/dashboard-routing.module';
import { billingRoutes } from '../features/billing/billing-routing.module';
import { taxReportRoutes } from '../features/tax-report/tax-report-routing.module';
import { zipFileRoutes } from '../features/zip-file/zip-file-routing.module';
import { ValidateOtpComponent } from '../validate-otp/validate-otp.component';
import { LoginAdminComponent } from '../login-admin/login-admin.component';
import { downloadRoutes } from '../features/download/download-routing.module';
import { emailDashboardroutes } from '../features/email-dashboard/email-dashboard-routing.module';
import { emailDashboardOverdueroutes } from '../features/email-dashboard-overdue/email-dashboard-overdue-routing.module';
import { QrCodeComponent } from '../qr-code/qr-code.component';
import { powerBIDashboardRoutes } from '../features/power-bi-dashboard/power-bi-dashboard-routing.module';
import { manageRequestRoutes } from '../features/manage-request/manage-request-routing.module';
import { operationLogRoutes } from "../features/operation-log/operation-log-routing.module";
export var mainRoutes = [
    // for role IT, default page is /dashboard-it
    // for role Accounttant, default page is /taxReport
    // more information is in constructor of file 'dashboard-list.component.ts'
    // for send email and sms qr code is QrcodeComponent
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'validate-otp', component: ValidateOtpComponent },
    { path: 'validate-otp/:msg', component: ValidateOtpComponent },
    { path: 'login/:msg', component: LoginComponent },
    // { path: 'login', component: LoginComponent },
    { path: 'login', component: LoginAdminComponent },
    { path: 'qr-code/:id', component: QrCodeComponent },
    {
        path: '',
        component: MainComponent,
        children: documentRoutes.concat(reportRoutes, searchRoutes, dashboardRoutes, billingRoutes, saleTaxRoutes, profileRoutes, taxReportRoutes, zipFileRoutes, downloadRoutes, emailDashboardroutes, emailDashboardOverdueroutes, powerBIDashboardRoutes, manageRequestRoutes, operationLogRoutes),
        canActivate: [AuthGuard]
    },
    { path: 'download-request', component: DownloadRequestComponent },
    { path: '**', redirectTo: '/dashboard', pathMatch: 'full' }
];
var MainRoutingModule = (function () {
    function MainRoutingModule() {
    }
    return MainRoutingModule;
}());
export { MainRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/main/main-routing.module.ts.pre-build-optimizer.js